import { HeaderContextType } from '@types/HeaderContextType.types';
import { useContext, useEffect } from 'react';
import HeaderContext from './HeaderContext';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@uidotdev/usehooks';

type UseHeaderParams = Partial<
    Pick<
        HeaderContextType,
        | 'title'
        | 'fabAction'
        | 'options'
        | 'quickActions'
        | 'titleSuffix'
        | 'searchProps'
    >
>;

const useHeader = ({
    title,
    quickActions,
    fabAction,
    options,
    searchProps,
    titleSuffix,
}: UseHeaderParams): void => {
    const { t } = useTranslation();
    useDocumentTitle(t('Donbar') + (title ? ` | ${title}` : ''));
    const {
        setTitle,
        setQuickActions,
        setFabAction,
        setOptions,
        setSearchProps,
        setTitleSuffix,
    } = useContext(HeaderContext) as HeaderContextType;

    useEffect(() => {
        setTitle(title);
        setQuickActions(quickActions);
        setFabAction(fabAction);
        setOptions(options);
        setSearchProps(searchProps);
        setTitleSuffix(titleSuffix);
        return () => {
            setTitle(undefined);
            setQuickActions(undefined);
            setFabAction(undefined);
            setOptions(undefined);
            setSearchProps(undefined);
            setTitleSuffix(undefined);
        };
    }, [title, quickActions, fabAction, options, searchProps, titleSuffix]);
};

export default useHeader;
